'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#chat_svg__a)" clipRule="evenodd"><path d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-2a1 1 0 1 1 0-2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8.5a1 1 0 1 1 0 2H4a4 4 0 0 1-4-4z" /><path d="M12.22 18.375a1 1 0 0 1 1.405-.156L17 20.92V19a1 1 0 1 1 2 0v4a1 1 0 0 1-1.625.78l-5-4a1 1 0 0 1-.156-1.405M11 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0M15 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0" /></g><defs><clipPath id="chat_svg__a"><path fill="currentColor" d="M0 0h24v24H0z" /></clipPath></defs></svg>;
const IconChat = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconChat;